import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelDynamic as _vModelDynamic, vShow as _vShow, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/profile-login.svg'
import _imports_1 from '@/app/ui/assets/svg/refresh.svg'
import _imports_2 from '@/app/ui/assets/svg/eye.svg'
import _imports_3 from '@/app/ui/assets/svg/invisible.svg'
import _imports_4 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'
import _imports_5 from '@/app/ui/assets/svg/login-img.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5a0891b6")

_pushScopeId("data-v-5a0891b6")
const _hoisted_1 = { class: "flex flex-col lg:flex-row text-12px xxl:text-14px items-center" }
const _hoisted_2 = { class: "w-full lg:w-2/5 p-8 xl:px-20 relative h-screen flex flex-col justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row items-center gap-x-2 mb-8"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "w-5",
  alt: "username-account",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "font-semibold text-14px font-montserrat text-black-lp-300" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "cursor-pointer w-4",
  alt: "change-account",
  src: _imports_1
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", {
  class: "font-semibold text-12px font-montserrat",
  style: {"color":"#b82025"}
}, " Ubah Akun ", -1)
const _hoisted_8 = {
  key: 1,
  class: "text-28px xxl:text-36px text-custom-100 font-semibold mt-4 mb-8 font-montserrat"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Log In to ")
const _hoisted_10 = {
  key: 2,
  class: "text-28px xxl:text-36px text-custom-100 font-semibold mt-4 mb-8 font-montserrat"
}
const _hoisted_11 = { class: "inline-block relative w-full" }
const _hoisted_12 = {
  key: 0,
  src: _imports_2,
  alt: "eye",
  class: "h-4 xxl:h-6"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_3,
  alt: "",
  class: "h-4 xxl:h-6"
}
const _hoisted_14 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pr-5 md:pr-0" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  class: "w-5 mr-3",
  alt: "exclamation circle solid"
}, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "text-12px xxl:text-14px text-red-lp-700 mb-2 mx-4 font-montserrat"
}
const _hoisted_17 = {
  key: 1,
  class: "text-red-lp-700 mb-2 mx-4 text-12px xxl:text-14px font-montserrat"
}
const _hoisted_18 = { class: "flex flex-row justify-between my-6" }
const _hoisted_19 = { class: "flex flex-row items-center" }
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "ml-2 text-custom-100 text-12px xxl:text-sm opacity-75 font-montserrat" }, " Remember Me ", -1)
const _hoisted_21 = {
  key: 2,
  class: "flex flex-row mt-6 font-montserrat justify-center"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-custom-100 text-12px xxl:text-sm" }, " Belum punya akun Lion Parcel? ", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("a", {
  href: "https://lionparcel.com/register",
  target: "_blank",
  class: "ml-1 text-red-lp-700 font-bold text-12px xxl:text-sm cursor-pointer"
}, "Daftar", -1)
const _hoisted_24 = {
  key: 4,
  class: "flex-grow overflow-auto"
}
const _hoisted_25 = { class: "w-11/12 flex flex-row" }
const _hoisted_26 = /*#__PURE__*/_createVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 17",
  fill: "currentColor",
  class: "icon-card-console",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.85714 3.49967C2.85714 3.05765 3.03775 2.63372 3.35925 2.32116C3.68074 2.0086 4.11677 1.83301 4.57143 1.83301H11.4286C11.8832 1.83301 12.3193 2.0086 12.6408 2.32116C12.9622 2.63372 13.1429 3.05765 13.1429 3.49967V13.4997C13.3702 13.4997 13.5882 13.5875 13.749 13.7438C13.9097 13.9 14 14.112 14 14.333C14 14.554 13.9097 14.766 13.749 14.9223C13.5882 15.0785 13.3702 15.1663 13.1429 15.1663H10V12.4997C10 11.3951 9.10457 10.4997 8 10.4997C6.89543 10.4997 6 11.3951 6 12.4997V15.1663H2.85714C2.62981 15.1663 2.4118 15.0785 2.25105 14.9223C2.09031 14.766 2 14.554 2 14.333C2 14.112 2.09031 13.9 2.25105 13.7438C2.4118 13.5875 2.62981 13.4997 2.85714 13.4997V3.49967ZM5.33333 5.16634C5.33333 4.79815 5.63181 4.49967 6 4.49967H6.66667C7.03486 4.49967 7.33333 4.79815 7.33333 5.16634C7.33333 5.53453 7.03486 5.83301 6.66667 5.83301H6C5.63181 5.83301 5.33333 5.53453 5.33333 5.16634ZM6 7.16634C5.63181 7.16634 5.33333 7.46482 5.33333 7.83301C5.33333 8.2012 5.63181 8.49967 6 8.49967H6.66667C7.03486 8.49967 7.33333 8.2012 7.33333 7.83301C7.33333 7.46482 7.03486 7.16634 6.66667 7.16634H6ZM8.66667 5.16634C8.66667 4.79815 8.96514 4.49967 9.33333 4.49967H10C10.3682 4.49967 10.6667 4.79815 10.6667 5.16634C10.6667 5.53453 10.3682 5.83301 10 5.83301H9.33333C8.96514 5.83301 8.66667 5.53453 8.66667 5.16634ZM9.33333 7.16634C8.96514 7.16634 8.66667 7.46482 8.66667 7.83301C8.66667 8.2012 8.96514 8.49967 9.33333 8.49967H10C10.3682 8.49967 10.6667 8.2012 10.6667 7.83301C10.6667 7.46482 10.3682 7.16634 10 7.16634H9.33333Z"
  })
], -1)
const _hoisted_27 = { class: "title-card-console" }
const _hoisted_28 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "icon-card-console",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.293 14.707C7.106 14.519 7 14.265 7 14c0-.265.106-.52.293-.707L10.586 10 7.293 6.707c-.096-.092-.172-.203-.224-.325-.053-.122-.08-.253-.081-.386-.001-.132.024-.264.074-.387.05-.123.125-.235.219-.328.093-.094.205-.169.328-.219.123-.05.255-.075.387-.074.133 0 .264.028.386.08.122.053.233.13.325.225l4 4c.188.188.293.442.293.707 0 .265-.105.52-.293.707l-4 4C8.519 14.894 8.265 15 8 15c-.265 0-.52-.106-.707-.293z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_29 = { class: "flex flex-row justify-center gap-x-1 mt-6" }
const _hoisted_30 = /*#__PURE__*/_createVNode("p", { class: "text-12px font-normal text-gray-lp-800" }, " Tidak memilih Hub? ", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("img", {
  class: "w-full lg:w-3/5 object-cover h-screen",
  src: _imports_5,
  alt: "banner"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.showHubList)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("p", _hoisted_5, _toDisplayString(_ctx.username), 1),
              _createVNode("div", {
                class: "flex flex-row items-center gap-x-2 cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPopupLogout = true))
              }, [
                _hoisted_6,
                _hoisted_7
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("img", {
          src: require(`@/app/ui/assets/${_ctx.loginModuleData.logo}`),
          class: "w-44 xxl:w-64",
          alt: "logo genesis"
        }, null, 8, ["src"]),
        (!_ctx.showHubList)
          ? (_openBlock(), _createBlock("p", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createVNode("span", null, null, 512), [
                [_directive_sanitize_html, _ctx.loginModuleData.title]
              ])
            ]))
          : (_openBlock(), _createBlock("p", _hoisted_10, " Choose HUB Consol ")),
        (!_ctx.showHubList)
          ? (_openBlock(), _createBlock("form", {
              key: 3,
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
            }, [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.email = $event)),
                id: "email",
                autocomplete: "username",
                type: _ctx.loginModuleData.type,
                prefix: _ctx.loginModuleData.prefix,
                placeholder: _ctx.loginModuleData.placeholderEmail,
                error: _ctx.loginModuleData.isErrorEmail,
                errorCaption: _ctx.loginModuleData.emailErrorMessage,
                format: _ctx.onFormatEmailPhone,
                onChange: _ctx.onInputEmail,
                onFocus: _ctx.onInvalidInput,
                onBlur: _ctx.onInvalidInput
              }, null, 8, ["modelValue", "type", "prefix", "placeholder", "error", "errorCaption", "format", "onChange", "onFocus", "onBlur"]),
              _createVNode("div", _hoisted_11, [
                _withDirectives(_createVNode("input", {
                  type: _ctx.passwordType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.password = $event)),
                  autocomplete: "current-password",
                  placeholder: _ctx.loginModuleData.placeholderPassword,
                  class: ["block appearance-none w-full bg-white border\n        focus:border-red-lp-100 px-3 xxl:px-4 py-2 xxl:py-3 pr-8 xxl:pr-8 my-4 rounded\n        shadow leading-tight focus:outline-none focus:shadow-outline", {
              'border-red-lp-700': _ctx.invalidPassword || _ctx.errorPassword,
              'border-2': !_ctx.invalidPassword || !_ctx.errorPassword
            }],
                  onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onInputPassword && _ctx.onInputPassword(...args)))
                }, null, 42, ["type", "placeholder"]), [
                  [_vModelDynamic, _ctx.password]
                ]),
                _createVNode("button", {
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showPassword && _ctx.showPassword(...args))),
                  class: "cursor-pointer absolute inset-y-0 right-0 flex items-center px-3 xxl:px-6 text-gray-500 focus:outline-none"
                }, [
                  (_ctx.iconType === 'eye')
                    ? (_openBlock(), _createBlock("img", _hoisted_12))
                    : (_openBlock(), _createBlock("img", _hoisted_13))
                ]),
                _withDirectives(_createVNode("div", _hoisted_14, [
                  _hoisted_15
                ], 512), [
                  [_vShow, _ctx.invalidPassword || _ctx.errorPassword]
                ])
              ]),
              (_ctx.invalidPassword)
                ? (_openBlock(), _createBlock("p", _hoisted_16, " Input your password "))
                : _createCommentVNode("", true),
              (_ctx.errorPassword)
                ? (_openBlock(), _createBlock("p", _hoisted_17, " Your password is incorrect. Check or reset "))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, [
                  _withDirectives(_createVNode("input", {
                    type: "checkbox",
                    class: "bg-red-lp-100",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.checked = $event)),
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setChecked && _ctx.setChecked(...args)))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.checked]
                  ]),
                  _hoisted_20
                ]),
                _createVNode("div", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onForgotPassword && _ctx.onForgotPassword(...args))),
                  class: "text-red-lp-700 font-medium text-12px xxl:text-sm cursor-pointer font-montserrat"
                }, " Forgot Password? ")
              ]),
              _createVNode(_component_button_fill, {
                id: "login",
                type: "submit",
                custom: "bg-red-lp-200 w-full",
                title: "Log In",
                onClick: _ctx.submit,
                isLoading: _ctx.isLoading
              }, null, 8, ["onClick", "isLoading"]),
              (_ctx.isSenderAccount)
                ? (_openBlock(), _createBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _hoisted_23
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_Footer)
            ], 32))
          : (_openBlock(), _createBlock("div", _hoisted_24, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hubList, (key) => {
                return (_openBlock(), _createBlock("div", {
                  key: key,
                  class: "card-console",
                  onClick: ($event: any) => (_ctx.onClickHub(key))
                }, [
                  _createVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode("p", _hoisted_27, _toDisplayString(key.hubName), 1)
                  ]),
                  _hoisted_28
                ], 8, ["onClick"]))
              }), 128)),
              _createVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode("p", {
                  class: "text-12px font-medium text-red-lp-200 cursor-pointer",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.unChooseHub && _ctx.unChooseHub(...args)))
                }, " Klik disini ")
              ])
            ]))
      ]),
      _hoisted_31
    ]),
    (_ctx.isErrorInternetOrSystem)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          onCancel: _ctx.handleErrorClose,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.submit,
          modal: ""
        }, null, 8, ["onCancel", "errorType", "onTryAgain"]))
      : _createCommentVNode("", true),
    (_ctx.errorInactiveAccount || _ctx.isForgotPassword)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          title: _ctx.loginModuleData.dialogData.title,
          message: _ctx.loginModuleData.dialogData.message,
          image: _ctx.loginModuleData.dialogData.image,
          textSuccess: _ctx.loginModuleData.dialogData.textSuccess,
          onSubmit: _ctx.loginModuleData.dialogData.onClose
        }, null, 8, ["title", "message", "image", "textSuccess", "onSubmit"]))
      : _createCommentVNode("", true),
    (_ctx.showPopupLogout)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          title: _ctx.popupLogout.title,
          message: _ctx.popupLogout.message,
          image: _ctx.popupLogout.image,
          textSuccess: _ctx.popupLogout.textSuccess,
          textCancel: _ctx.popupLogout.textCancel,
          onSubmit: _ctx.popupLogout.onSubmit,
          onClose: _ctx.popupLogout.onClose
        }, null, 8, ["title", "message", "image", "textSuccess", "textCancel", "onSubmit", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isHubError)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 3,
          title: _ctx.popupErrorHub.title,
          message: _ctx.popupErrorHub.message,
          image: _ctx.popupErrorHub.image,
          textSuccess: _ctx.popupErrorHub.textSuccess,
          textCancel: _ctx.popupErrorHub.textCancel,
          onSubmit: _ctx.popupErrorHub.onSubmit,
          onClose: _ctx.popupErrorHub.onClose
        }, null, 8, ["title", "message", "image", "textSuccess", "textCancel", "onSubmit", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
})